import siteConfig from "site-config";
import { baseActionEpic, IRequestDataAction } from "./base-epic";
import { WORKING_ORDER } from "constants/action-types";
import { IWorkingDraftsState } from "reducers/working-order/working";

export const validateEpic = baseActionEpic<IRequestDataAction<any>, IWorkingDraftsState>(
    WORKING_ORDER.DRAFTS.VALIDATE,
    ({ payload }) => ({
        url: siteConfig.api + payload.url,
        method: "PUT",
        body: payload.body,
    }),
    ({ response }) => {
        return [
            {
                type: WORKING_ORDER.DRAFTS.UPDATE,
                payload: {
                    isValid: response.valid,
                    validationError: !response.valid
                        ? { summary: response.localizedMessage, messages: response.errors }
                        : null,
                    isValidating: false,
                },
            },
        ];
    }
);
